import styles from "./TicketFilters.module.css";

export type SortKey = "price-asc" | "price-desc" | "best";

type Props = {
  count: number;
  total: number;
  qty: number | "any";
  setQty: (q: number | "any") => void;
  sort: SortKey;
  setSort: (s: SortKey) => void;
};

const QTY_OPTIONS: Array<number | "any"> = ["any", 1, 2, 3, 4, 6];

export default function TicketFilters({
  count,
  total,
  qty,
  setQty,
  sort,
  setSort,
}: Props) {
  return (
    <div className={styles.bar}>
      <div className={styles.summary}>
        <strong>{count}</strong>
        <span className={styles.summarySub}>
          {count === total ? "listings" : `of ${total} listings`}
        </span>
      </div>

      <div className={styles.group}>
        <span className={styles.label}>Tickets</span>
        <div className={styles.chips}>
          {QTY_OPTIONS.map((opt) => (
            <button
              key={String(opt)}
              type="button"
              className={`${styles.chip} ${qty === opt ? styles.chipActive : ""}`}
              onClick={() => setQty(opt)}
            >
              {opt === "any" ? "Any" : opt}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.group}>
        <span className={styles.label}>Sort</span>
        <select
          className={styles.select}
          value={sort}
          onChange={(e) => setSort(e.target.value as SortKey)}
        >
          <option value="best">Best</option>
          <option value="price-asc">Price (low to high)</option>
          <option value="price-desc">Price (high to low)</option>
        </select>
      </div>
    </div>
  );
}
